import type { Cmcd } from './Cmcd.ts'
import type { CmcdData } from './CmcdData.ts'
import type { CmcdDecodeOptions } from './CmcdDecodeOptions.ts'
import { decodeCmcd } from './decodeCmcd.ts'

/**
 * Decode CMCD data from a URL encoded string.
 *
 * A `+` decodes as a space, as in `application/x-www-form-urlencoded`.
 * A `%2B` decodes as a `+`.
 *
 * @param url - The URL encoded string to decode.
 * @param options - Options for decoding.
 *
 * @returns The decoded CMCD data.
 *
 * @see {@link https://cta-wave.github.io/Resources/common-media-client-data--cta-5004-b.html#query-argument-definition | CTA-5004-B Query Argument Definition}
 *
 * @public
 *
 * @example
 * {@includeCode ../test/fromCmcdUrl.test.ts#example}
 */
export function fromCmcdUrl(url: string, options: CmcdDecodeOptions & { convertToLatest: true }): Cmcd
export function fromCmcdUrl(url: string, options?: CmcdDecodeOptions): CmcdData
export function fromCmcdUrl(url: string, options?: CmcdDecodeOptions): CmcdData | Cmcd {
	return decodeCmcd(decodeURIComponent(url.replace(/^CMCD=/, '').replace(/\+/g, ' ')), options as CmcdDecodeOptions)
}
